export var MVPTypeEnum;
(function (MVPTypeEnum) {
    MVPTypeEnum[MVPTypeEnum["Internal"] = 0] = "Internal";
    MVPTypeEnum[MVPTypeEnum["External"] = 1] = "External";
})(MVPTypeEnum || (MVPTypeEnum = {}));
